<template>
  <div class="made-order">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 style="width:300px"
                 placeholder="输入订单号/用户手机号/领取人手机号..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.order_status"
                  :style="{'width':'150px'}"
                  placeholder="选择订单状态..."
                  clearable>
            <Option v-for="item in orderStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.pay_status"
                  :style="{'width':'150px'}"
                  placeholder="选择支付状态..."
                  clearable>
            <Option v-for="item in payStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      @on-change="changeDate"
                      style="width: 260px"
                      placeholder="下单时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>&nbsp;
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportOrder()">导出订单</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table max-height="600"
           border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"
           class="B2CList"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer width="50"
            v-model="modal1"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="modal1 = false">
      <Form :model="detaildata"
            label-position="left"
            :label-width="100">
        <Row>
          <Col :xs="24"
               :md="24">
          <FormItem label="支付订单编号">
            <span>{{ detaildata.pay_order_num }}</span>
          </FormItem>
          <FormItem label="支付方式">
            <span>{{ detaildata.pay_name }}</span>
          </FormItem>
          <FormItem label="支付金额">
            <span>{{ detaildata.total_prices }}</span>
          </FormItem>
          <FormItem label="祝福">
            <span>{{ detaildata.wish }}</span>
          </FormItem>
          <FormItem label="配色">
            <span>{{ detaildata.fangan_title }}</span>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :xs="24"
               :md="24">
          <Table border
                 stripe
                 :columns="columsgood"
                 :data="datagood"></Table>
          </Col>
        </Row>

      </Form>
    </Drawer>
  </div>
</template>

<script>
// import expandRow from "./table-expand";

export default {
  name: "made-order",
  data () {
    return {
      orderStatusList: [
        { value: 2, label: "关闭" },
        { value: 1, label: "过期" },
        { value: 0, label: "正常" }
      ],
      payStatusList: [
        { value: 0, label: "未支付" },
        { value: 1, label: "支付中" },
        { value: 2, label: "支付完成" }
      ],
      dataloading: true,
      modal1: false,
      columsgood: [
        {
          title: "领取用户",
          key: "nickname",
          width: 185
          // fixed:"left"
        },
        {
          title: "手机号",
          key: "username",
          width: 185
          // fixed:"left"
        },
        {
          title: "开奖",
          key: "is_openbox",
          width: 100,
          render: (h, params) => {
            return h("span", params.row.is_openbox == 0 ? "未开奖" : "已开奖");
          }
        },
        {
          title: "领取奖品",
          key: "good_titles",
          width: 150
          // fixed:"left"
        }
      ],
      datagood: [],
      formItem: {
        key: "",
        order_status: "",
        pay_status: "",
        datetime: []
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      list: [
        {
          title: "id",
          key: "id",
          width: 80
          // fixed:"left"
        },
        {
          title: "支付订单号",
          key: "pay_order_num",
          width: 185
          // fixed:"left"
        },
        {
          title: "下单用户",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.user != null ? params.row.user.username : ""
            );
          }
        },
        {
          title: "单价",
          key: "price",
          width: 80
          // fixed:"left"
        },
        {
          title: "每人赠送数量",
          key: "manghe_num",
          width: 80
          // fixed:"left"
        },
        {
          title: "赠送人数",
          key: "person_num",
          width: 80
          // fixed:"left"
        },
        {
          title: "支付金额",
          key: "total_price",
          width: 100
          // fixed:"left"
        },
        {
          title: "支付方式",
          width: 100,
          align: "center",
          key: "pay_name"
        },
        {
          title: "支付状态",
          width: 100,
          align: "center",
          key: "pay_status",
          render: (h, params) => {
            return h(
              "div",
              params.row.pay_status == "0"
                ? "未支付"
                : params.row.pay_status == "1"
                  ? "支付中"
                  : "已完成"
            );
          }
        },
        {
          title: "支付时间",
          minWidth: 150,
          key: "pay_at"
        },
        {
          title: "领取状态",
          width: 100,
          align: "center",
          key: "lingqu_status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.lingqu_status == "2" ? "red" : "geekblue"
                }
              },
              params.row.lingqu_status == "0"
                ? "未领取"
                : params.row.lingqu_status == "1"
                  ? "领取中"
                  : "领取完成"
            );
          }
        },
        {
          title: "订单状态",
          width: 100,
          align: "center",
          key: "status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.status == "0" ? "geekblue" : "red"
                }
              },
              params.row.status == "0"
                ? "正常"
                : params.row.status == "1"
                  ? "过期"
                  : "关闭"
            );
          }
        },
        {
          title: "下单时间",
          minWidth: 150,
          key: "created_at"
        },

        {
          title: "操作",
          align: "center",
          key: "action",
          width: 80,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detailOrder(params.row.id);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      detaildata: {},
      exportLoading: false
    };
  },
  mounted: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    // 获取订单列表
    getTableList: function () {
      this.renderTable(1);
      return;
    },
    changeDate (val) {
      this.formItem.datetime = val;
    },

    // 分页
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },

    exportOrder () {
      this.exportLoading = true;
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      this.$api.manghemadeorder
        .exportboxorder({
          pay_begin_at: pay_begin_at,
          pay_end_at: pay_end_at
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    },
    detailOrder (id) {
      this.modal1 = true;
      var params = {
        id: id
      };
      this.$api.manghemadeorder.boxOrderDetail(params).then(res => {
        if (res.code == 200) {
          this.detaildata = res.result;
          this.datagood = res.result.goods;
        }
      });
    },
    // 查看详情
    detail: function (index) {
      this.modal1 = true;
      var params = {
        id: index
      };
      this.$api.manghemadeorder.goodsOrderDetail(params).then(res => {
        if (res.code == 200) {
          this.datagood = res.result.productgood;
          // this.detaildata.pay_order_num = res.result.order.pay_order_num;
          // this.detaildata.order_num = res.result.order_num;
          // this.detaildata.person = res.result.person;
          // this.detaildata.phone = res.result.phone;
          // this.detaildata.address = res.result.address;
          // this.detaildata.logistics_name = res.result.logistics_name;
          // this.detaildata.logistics_code = res.result.logistics_code;
          // this.detaildata.repal_returnmsg = res.result.order.repal_returnmsg;
        }
      });
      return;
    },
    cancelorder: function (index) {
      // 弹出确认框
      //   this.$Modal.confirm({
      //     title: "警告",
      //     content: "<p>此操作不可恢复，三思而后行...</p>",
      //     onOk: () => {
      //       this.$api.madeorder.cancel({ id: index }).then(res => {
      //         if (res.code == 200) {
      //           this.renderTable(1);
      //         }
      //       });
      //     }
      //   });
    },
    perChange: function (index) {
      this.logistics_id = index.value;
      this.logistics_name = index.label;
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.current = 1;
      }
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      let params = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        phone: this.formItem.phone,
        order_status: this.formItem.order_status,
        pay_status: this.formItem.pay_status,
        pay_begin_at: pay_begin_at,
        pay_end_at: pay_end_at
      };
      this.$api.manghemadeorder.boxOrderList(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
